import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { EmployeeAssetsService } from '../../../services/employee-assets.service';
import { AssetAction, EmployeeAsset, WorkflowError } from '../../../models/employee-asset.model';
import { ASSET } from './asset.constants';
import { assetErrorKey, assetOperationId } from './asset.helpers';

@Component({selector: 'app-asset-action-modal', templateUrl: './asset-action-modal.component.html',
  styleUrls: ['./asset-form.component.css']})
export class AssetActionModalComponent implements OnInit, OnDestroy {
  asset: EmployeeAsset;
  action: string;
  draft: AssetAction;
  constants = ASSET;
  errorKey = ASSET.empty;
  busy = false;
  refreshed = false;
  private destroyed = new Subject<void>();

  constructor(public modal: NgbActiveModal, private api: EmployeeAssetsService) {}

  ngOnInit(): void {
    this.draft = {operationId: assetOperationId(), expectedVersion: this.asset.version,
      action: this.action, reason: ASSET.empty, confirmed: false,
      quantity: this.action === ASSET.returnAction ? this.asset.remainingQuantity : undefined, damaged: false};
  }

  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }

  submit(): void {
    if (this.busy || !this.draft.confirmed || !this.permitted() || this.errorKey === ASSET.deniedKey || this.errorKey === ASSET.conflictKey) { return; }
    if (this.action === ASSET.revokeAccess && !this.draft.reason.trim()) { this.errorKey = ASSET.validationKey; return; }
    if (this.action === ASSET.returnAction && (!this.draft.quantity || this.draft.quantity < ASSET.one
      || this.draft.quantity > this.asset.remainingQuantity || this.draft.quantity % ASSET.one !== ASSET.zero)) { return; }
    this.busy = true;
    this.api.act(this.asset.id, this.draft).takeUntil(this.destroyed).subscribe(result => {
      this.modal.close(result);
    }, error => this.fail(error));
  }

  refresh(): void {
    this.busy = true;
    this.api.get(this.asset.id).takeUntil(this.destroyed).subscribe(result => {
      this.asset = result; this.draft.expectedVersion = result.version;
      this.draft.operationId = assetOperationId(); this.draft.confirmed = false;
      this.refreshed = true; this.busy = false; this.errorKey = ASSET.empty;
      if (result.allowedActions.indexOf(this.action) < ASSET.zero) { this.errorKey = ASSET.deniedKey; }
    }, error => this.fail(error));
  }

  private fail(error: WorkflowError): void {
    this.busy = false; this.errorKey = assetErrorKey(error, true);
  }
  private permitted(): boolean {
    return (this.action === ASSET.revokeAccess || this.action === ASSET.returnAction)
      && (this.asset.allowedActions || []).indexOf(this.action) >= ASSET.zero;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/asset-action-modal.component.ts